import { useEffect } from "react";
import { auth } from 'utils/firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { getProfile } from "apis/profile";
import { useLocation, useNavigate } from "react-router";
import useAuth from "./useAuth";

export function useAppInit() {
  const { setAuth, setLoadingAuth, setLoadingInit, resetAuth, user, loadingAuth, loadingInit } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname !== "/forgot-password" && !loadingInit && !loadingAuth && !user) {
      navigate('/');
    }
  }, [location.pathname, navigate, user, loadingAuth, loadingInit]);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        try {
          setLoadingAuth(true);
          const profileData = await getProfile(currentUser?.uid);
          if (profileData) {
            setAuth({
              user: profileData,
              loadingAuth: false,
            });
          } else {
            resetAuth();
          }
        } catch (error) {
          console.log('error in useAppInit:', error);
          resetAuth();
        }
      } else {
        resetAuth();
        setLoadingInit(false);
      }
    });

    return () => {
      unsubscribe();
    };
  }, [navigate, resetAuth, setAuth, setLoadingAuth, setLoadingInit]);
}
